import suppressKeyboard from '../../utils/suppressKeyboard';

// The base of a subRowControl column definition.
// Requires the cellClass and cellRendererParams to be added to be complete
export const defaultSubRowControlColumnDef = {
  cellRenderer: 'subRowControl',
  colId: 'subRowControl',
  hide: false,
  lockPosition: true,
  sortable: false,
  suppressKeyboardEvent: suppressKeyboard,
  suppressSizeToFit: true,
  width: 40
};

// The matching ag grid column state for the subRowControl column
// Add this to your initial column state to ensure ag grid doesn't hide the column on you
// for calling columnApi.setColumnState() with an state array that doesn't include the
// subRowControl column
export const defaultSubRowControlColumnState = {
  aggFunc: null,
  colId: 'subRowControl',
  hide: false,
  pinned: null,
  pivotIndex: null,
  rowGroupIndex: null,
  width: 40
};
